import PropTypes from "prop-types";
import classNames from "classnames";
import { RECORDING_STATUS } from "../../../../constants/voiceRecord";
import startRecordIcon from "../../../../assets/icons/start_record.svg";
import recordingIcon from "../../../../assets/icons/recording.svg";
import classes from "./RecordButton.module.css";

const RecordButton = (props) => {
  const { recordingStatus, error, ...rest } = props;
  return (
    <button
      className={classNames(classes["record-btn"], {
        [classes["record-btn--error"]]: error,
        [classes["record-btn--recording"]]:
          recordingStatus === RECORDING_STATUS.RECORDING,
      })}
      {...rest}
    >
      <img
        src={
          recordingStatus === RECORDING_STATUS.INACTIVE
            ? startRecordIcon
            : recordingIcon
        }
        alt={
          recordingStatus === RECORDING_STATUS.INACTIVE
            ? "ابدء التسجيل"
            : "أوقف التسجيل"
        }
        className={classes["record-btn__img"]}
      />
    </button>
  );
};

export default RecordButton;

RecordButton.propTypes = {
  recordingStatus: PropTypes.oneOf(Object.values(RECORDING_STATUS)),
  error: PropTypes.bool,
};
